export default __webpack_public_path__ + "locales/el-GR/VersionHistory.json?hash=8a8c0a55292c3549c21f3e5d3d672090";